import React, { createRef, Fragment, FunctionComponent, useEffect } from "react";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

import { AnimatedWidth, AnimationPhase } from "@multiweb/reactComponents";
import { ANIMATION_DURATION_MS, bemClassNames, clamp } from "@multiweb/reactUtils";
import { MENU_PANEL_WIDTH, MENU_WIDTH } from "../../constants";
import { ActionItemBackgroundContext } from "../../context";
import { MenuScrollLayout } from "../MenuScrollLayout";
import { Submenu } from "../Submenu";
import { SubmenuListComponentProps } from "./SubmenuListComponentProps";

export { SubmenuListComponentProps };

const classNames = bemClassNames("submenu-list-component");

/** Komponenta obaluje všechny otevřené podmenu a umožňuje horizontální posouvání v případě přílišné šířky. */
export const SubmenuListComponent: FunctionComponent<SubmenuListComponentProps> = ({
    submenuIds,
}) => {
    const ref = createRef<OverlayScrollbarsComponent>();
    const submenuListWidth = MENU_WIDTH * submenuIds.length;
    const maximalSubmenuListWidth = window.innerWidth - MENU_WIDTH - MENU_PANEL_WIDTH - 0.1 * window.innerWidth;
    const width = clamp(submenuListWidth, 0, maximalSubmenuListWidth);

    useEffect(() => {
        if (ref && ref.current) {
            const instance = ref.current.osInstance();
            if (instance) {
                // Použití maximálního celého čísla pro posun. Dle dokumentsce je možné zadat maximální posun
                // doprava hodnotou "100%". Toto použití však využívá funkci eval, která způsobí pád aplikace.
                instance.scroll({ x: Number.MAX_SAFE_INTEGER }, ANIMATION_DURATION_MS);
            }
        }
        // TODO [MB] - Opravit hook deps v rámci 30853.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submenuIds]);

    return (
        <div className={classNames()}>
            <AnimatedWidth
                animationDurationMs={ANIMATION_DURATION_MS}
                animationPhase={AnimationPhase.start}
                {...{ width }}
            >
                <div className={classNames("content")}>
                    <MenuScrollLayout
                        usePaddedScrollbars={true}
                        vertical={false}
                        {...{ ref }}
                    >
                        <div className={classNames("content")}>
                            <ActionItemBackgroundContext.Provider value={true}>
                                {submenuIds.map((submenuId, index) => (
                                    <Fragment key={submenuId}>
                                        <Submenu {...{ submenuId }} />
                                        {(index < submenuIds.length - 1) && (
                                            <div className={classNames("divider")} />
                                        )}
                                    </Fragment>
                                ))}
                            </ActionItemBackgroundContext.Provider>
                        </div>
                    </MenuScrollLayout>
                </div>
            </AnimatedWidth>
        </div>
    );
};
